@if (!store.isOnline()) {
  <div class="banner">
    {{ notification }}
    <div class="refresh-button" disabled="disabled" (click)="refresh()">
      @if (checkingConnection()) {
        Checking connection...
      } @else {
        Check connection
      }
    </div>
  </div>
}
